import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { ApiResult } from "../../../../types/ApiResult";
import { ReleasePurchaseOrderFromPendingParams } from "../types/ReleasePurchaseOrderFromPendingParams";

export const useReleasePurchaseOrderFromPending = (
	onSuccess: () => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async (params: ReleasePurchaseOrderFromPendingParams) => {
			return await apiClient.post("purchase-order/release-from-pending", params) as ApiResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess();
			else
				onError('Error when releasing the purchase order from pending status: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
